import {ReactElement, useState} from "react";
import {Field, Label, Message} from "@zendeskgarden/react-forms";
import {CustomZDDropdown} from "../../../../atoms/custom-zd-dropdown/CustomZDDropdown";
import {PayrollDefaultLevel} from "../../../../__generated__/generated_types";
import {useProperties} from "../../../../contexts/properties/PropertiesContext";
import DefaultsForm from "./DefaultsForm";
import styles from "./PayrollDefaults.module.scss";
import DefaultsFormWithInitialData from "./DefaultsFormWithInitialData";

interface PropertyDefaultsFormProps {
    positionIds: string[];
}

export default function PropertyDefaultsForm(props: PropertyDefaultsFormProps): ReactElement {
    const {positionIds} = props;
    const [selectedPropertyIds, setSelectedPropertyIds] = useState<string[]>([]);
    const {properties} = useProperties();
    const selectedPositionId = positionIds[0] ?? "";
    const selectedPropertyId = selectedPropertyIds[0] ?? "";
    const canLoadInitialData = positionIds.length === 1
        && selectedPositionId
        && selectedPropertyIds.length === 1
        && selectedPropertyId;

    if(positionIds.length === 0) {
        return <div className={styles.positionSelectorMessage}>Select a position to configure defaults.</div>;
    }

    return (
        <>
            <div className={styles.propertySelector}>
                <Field className={styles.field}>
                    <Label className={styles.label}>Property</Label>
                    <CustomZDDropdown
                        widthSpec={"100%"}
                        applySelectedItems={(items) => {
                            const values = Array.isArray(items) ? items : [items];
                            setSelectedPropertyIds(values.filter(Boolean) as string[]);
                        }}
                        initialSelectedItems={selectedPropertyIds}
                        openDropdownPlaceholder="Select Property"
                        closedDropdownPlaceholder=""
                        options={(properties ?? []).map(p => ({value: p.id, label: p.name}))}
                        isError={false}
                        isMulti
                        allOption
                        noSearchIcon
                    />
                    {selectedPropertyIds.length > 1 &&
                        <Message className={styles.selectorMessage} validation="warning">
                            Saving will overwrite existing defaults for all selected properties.
                        </Message>
                    }
                    {selectedPropertyIds.length === 0 &&
                        <Message className={styles.selectorMessage}>Select a property to configure defaults.</Message>
                    }
                </Field>
            </div>
            {canLoadInitialData ?
                <DefaultsFormWithInitialData
                    positionId={selectedPositionId}
                    defaultLevel={PayrollDefaultLevel.Property}
                    propertyId={selectedPropertyId}
                /> :
                selectedPropertyIds.length > 0 ?
                    <DefaultsForm
                        positionIds={positionIds}
                        defaultLevel={PayrollDefaultLevel.Property}
                        propertyIds={selectedPropertyIds}
                        showResetControls={false}
                    /> :
                    <></>
            }
        </>
    );
}
